// import React from 'react';
// import '../../styles/Css/EarlyAccess.css'

// const EarlyAccess = () => {

//     return (
//         <div className="landing-container">
//             {/* Top Badge */}
//             <div className="early-access-badge">
//                 <span className="star">★</span> LIMITED EARLY ACCESS
//             </div>

//             <header className="hero-section">
//                 <h1>Join the First 300 Founding Users</h1>
//                 <p>
//                     We're onboarding users in limited batches to ensure the best experience.
//                     Get exclusive founding member benefits.
//                 </p>
//             </header>

//             <div className="info-cards">
//                 {/* Price Card */}
//                 <div className="card price-card">
//                     <div className="price-highlight">$10/month LOCKED FOR LIFE</div>
//                     <p className="regular-price">Regular price: $29/month</p>
//                 </div>

//                 {/* Features Card */}
//                 <div className="card features-card">
//                     <ul>
//                         <li><span className="star">★</span> Priority access to new AI features</li>
//                         <li><span className="star">★</span> Direct founder support</li>
//                         <li><span className="star">★</span> Early feature influence</li>
//                         <li><span className="star">★</span> Onboarding & migration help</li>
//                         <li><span className="star">★</span> Exclusive founding member badge</li>
//                         <li><span className="star">★</span> Lifetime price guarantee</li>
//                     </ul>
//                 </div>
//             </div>

//             {/* Form Section */}
//             <div className="form-container">
//                 <form className="waitlist-form">
//                     <div className="form-row">
//                         <input type="text" placeholder="Full Name" />
//                         <input type="email" placeholder="Email Address" />
//                     </div>
//                     <input type="tel" placeholder="Phone Number" />
//                     <input type="text" placeholder="Brokerage/Company Name" />
//                     <select>
//                         <option value="" disabled selected>Select Your Role</option>
//                         <option value="agent">Agent</option>
//                         <option value="broker">Broker</option>
//                         <option value="other">Other</option>
//                     </select>
//                     <button type="submit" className="submit-btn">
//                         Join the Waitlist →
//                     </button>
//                 </form>

//                 {/* Progress Bar */}
//                 <div className="progress-section">
//                     <div className="progress-stats">
//                         <span>Spots Remaining</span>
//                         <span className="spots-count">53/300</span>
//                     </div>
//                     <div className="progress-bar-bg">
//                         <div className="progress-bar-fill" style={{ width: '82%' }}></div>
//                     </div>
//                     <p className="footer-text">Join 247 agents already on the list</p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EarlyAccess;


import React from "react";
import FoundingMemberSection from "../FoundingMembers";

const Features = () => {
    return (
        <div style={{ marginTop: "73px" }}>
            <FoundingMemberSection />
        </div>
    )
}

export default Features;